import { render, staticRenderFns } from "./AuditAppraisal.vue?vue&type=template&id=522af55f&scoped=true&"
import script from "./AuditAppraisal.vue?vue&type=script&lang=js&"
export * from "./AuditAppraisal.vue?vue&type=script&lang=js&"
import style0 from "./AuditAppraisal.vue?vue&type=style&index=0&id=522af55f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522af55f",
  null
  
)

export default component.exports